import React, { memo, useEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTopWrapper = (props) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return <>{props.children}</>;
};

export const ScrollToTop = memo(ScrollToTopWrapper);
